



















import { Component , Vue } from 'vue-property-decorator';
import TopNavigationBar from '../components/TopNavigationBar.vue';
import LeftNavigationBar from '../components/LeftNavigationBar.vue';
import '../assets/css/MainLayout.scss';
import '../assets/css/DashBoard.scss';
import '../assets/css/Footer.scss';
import '../assets/css/Left.scss';
import '../assets/css/Top.scss';
import { MedTransGoConstants } from '../util/constants';
import DocumentExpirationAlertModal from './modal/DocumentExpirationAlertModal.vue';
import { ObjectFactory } from '@/config/objectFactory';
import { DateUtils } from '@/util/dateUtils';
import { Document } from '@/types/entity';
import { ApiRequest, QueryRecordsRequest } from '@/types/request';
import { DriverProfile } from '@/types/response';
@Component({
    data() {
        return{
            transporterdocuments: [],
            languageCertificates: [],
        };
    },
    components: {
        TopNavigationBar,
        LeftNavigationBar,
        DocumentExpirationAlertModal,
    },
})
export default class MainLayout extends Vue {
    private showDocumentExpirationAlert = false;
    public mounted() {
        if (this.$route.path === '/') {
            this.$router.push({ name : MedTransGoConstants.VIEW_REQUESTS_PANEL_NAME });
        }
        this.getPartnerProfile();
    }

    private async getPartnerProfile() {
        const partnerService = ObjectFactory.getPartnerService();
        const response = await partnerService.getPartnerProfile(this.$store.state.serverUrl);
        if (response.success && response.data) {
            const partnerProfile = response.data;
            if (partnerProfile.transporterProfile && partnerProfile.transporterProfile.documents ) {
                partnerProfile.transporterProfile.documents.forEach((element) => {
                    element.status = element.verified ? 'Verified' : 'Not Verified';
                    if (element.expirationDate && element.expirationDate <= DateUtils.getCurrentTimeInMillis()) {
                        element.status = 'Expired';
                        this.$data.transporterdocuments = partnerProfile.transporterProfile ?
                        partnerProfile.transporterProfile.documents : [];
                        this.showDocumentExpirationAlertModal();
                    }
                });
            }
            if (partnerProfile.interpreterProfile && partnerProfile.interpreterProfile.languages) {
                partnerProfile.interpreterProfile.languages.forEach((element) => {
                    element.certificates.forEach((certificate) => {
                        if (certificate.expirationTime && certificate.expirationTime <=
                            DateUtils.getCurrentTimeInMillis()) {
                                certificate.status = 'EXPIRED';
                                this.$data.languageCertificates = partnerProfile.interpreterProfile ?
                                    partnerProfile.interpreterProfile.languages : [];
                                this.showDocumentExpirationAlertModal();
                        }
                    });
                });

            }
        }
    }

    private showDocumentExpirationAlertModal() {
        if (!sessionStorage.getItem('showDocumentModal')) {
            this.showDocumentExpirationAlert = true;
        }
    }

    private closeDocumentExpirationModal() {
        this.showDocumentExpirationAlert = false;
        sessionStorage.setItem('showDocumentModal', 'true');
    }
}
